"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOf = exports.select = exports.not = exports.when = void 0;
const symbols = require("./symbols");
const when = (predicate) => ({
    [symbols.PatternKind]: symbols.Guard,
    [symbols.Guard]: predicate,
});
exports.when = when;
const not = (pattern) => ({
    [symbols.PatternKind]: symbols.Not,
    [symbols.Not]: pattern,
});
exports.not = not;
function select(key) {
    return key === undefined
        ? {
            [symbols.PatternKind]: symbols.Select,
            [symbols.Select]: symbols.AnonymousSelectKey,
        }
        : {
            [symbols.PatternKind]: symbols.Select,
            [symbols.Select]: key,
        };
}
exports.select = select;
function isInstanceOf(classConstructor) {
    return (val) => val instanceof classConstructor;
}
const instanceOf = (classConstructor) => (0, exports.when)(isInstanceOf(classConstructor));
exports.instanceOf = instanceOf;
